import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/d/src/uu-data-dict/uu-data-dict/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "aan-de-slag-met-power-bi"
    }}>{`Aan de slag met Power BI`}</h1>
    <h2 {...{
      "id": "benodigdheden"
    }}>{`Benodigdheden`}</h2>
    <p>{`Voordat je aan de gang kunt met Power BI, heb je een aantal dingen nodig: `}</p>
    <ul>
      <li parentName="ul">{`Een computer met Windows. Power BI Desktop werkt niet op OS X of Linux.`}</li>
      <li parentName="ul">{`Een recente versie van `}<em parentName="li">{`Power BI Desktop`}</em>{`. Deze kun je downloaden op de `}<a parentName="li" {...{
          "href": "https://powerbi.microsoft.com/en-us/desktop/"
        }}>{`website van Microsoft`}</a>{`. We raden aan om de Engelse versie te gebruiken. Installeer Power BI voordat je verder gaat.`}</li>
      <li parentName="ul">{`Je Uurwerk gebruikersnaam en wachtwoord.`}</li>
      <li parentName="ul">{`Een `}<em parentName="li">{`OData feed`}</em>{`-adres. Deze heb je van ons ontvangen en lijkt op het volgende adres:`}</li>
    </ul>
    <pre><code parentName="pre" {...{}}>{`https://data.uurwerk.net/api/(theater).uurwerk.net/odata
`}</code></pre>
    <h2 {...{
      "id": "power-bi-openen"
    }}>{`Power BI openen`}</h2>
    <p>{`Voordat je verder gaat: zorg ervoor dat Power BI op je computer is geinstalleerd en je het kunt openen. Open Power BI Desktop, en sluit eventuele popup-vensters tot je het thuisscherm ziet:`}</p>
    <p><img alt="Het thuissscherm van Power BI Desktop" src={require("../public/powerbi-home.png")} /></p>
    <h2 {...{
      "id": "verbinding-maken-van-power-bi-naar-uurwerk"
    }}>{`Verbinding maken van Power BI naar Uurwerk`}</h2>
    <p>{`Om Uurwerk-gegevens in Power BI te bekijken, moet Power BI worden verteld waar die gegevens te vinden zijn.`}</p>
    <p>{`Power BI kan met verschillende gegevensbronnen werken, zoals databases en excel-bestanden. De Uurwerk-gegevens zijn beschikbaar als een `}<em parentName="p">{`OData feed`}</em>{`.
De OData feed van Uurwerk is te vinden op `}<a parentName="p" {...{
        "href": "https://data.uurwerk.net/api/(theater).uurwerk.net/odata"
      }}>{`https://data.uurwerk.net/api/(theater).uurwerk.net/odata`}</a>{`. Dit adres verschilt per theater. In de volgende stappen stellen we de OData feed in.`}</p>
    <p>{`In het `}<em parentName="p">{`Power BI `}<a parentName="em" {...{
          "href": "#power-bi-openen"
        }}>{`thuisscherm`}</a></em>{`, `}</p>
    <ul>
      <li parentName="ul">{`klik in het menu op `}<inlineCode parentName="li">{`Get Data`}</inlineCode></li>
      <li parentName="ul">{`kies voor `}<inlineCode parentName="li">{`Other`}</inlineCode></li>
      <li parentName="ul">{`kies voor `}<inlineCode parentName="li">{`OData feed`}</inlineCode></li>
      <li parentName="ul">{`klik op `}<inlineCode parentName="li">{`Connect`}</inlineCode>{`, het `}<em parentName="li">{`OData feed`}</em>{`-scherm verschijnt`}</li>
    </ul>
    <p><img alt="Een OData feed instellen" src={require("../public/powerbi-get-data.gif")} /></p>
    <p>{`In het `}<em parentName="p">{`OData feed`}</em>{`-scherm,`}</p>
    <ul>
      <li parentName="ul">{`vul bij URL het `}<em parentName="li">{`OData feed`}</em>{`-adres in. Vul het adres zorgvuldig in.`}</li>
      <li parentName="ul">{`klik op `}<em parentName="li">{`OK`}</em></li>
    </ul>
    {
      /* ![Een OData feed instellen](../public/powerbi-odata-url.png) */
    }
    <p><img alt="Een OData feed instellen" src={require("../public/powerbi-odata-url-single.png")} /></p>
    <p>{`Power BI vraagt nu of je anoniem wilt verbinden (`}<em parentName="p">{`Anonymous`}</em>{`).
In plaats van `}<em parentName="p">{`Anonymous`}</em>{` toegang,`}</p>
    <ul>
      <li parentName="ul">{`klik, in de lijst links, op `}<em parentName="li">{`Basic`}</em>{` `}</li>
    </ul>
    <p><img alt="Een OData feed instellen" src={require("../public/powerbi-odata-auth-anon.png")} /></p>
    <p>{`Power BI vraagt nu om je gebruikersnaam,`}</p>
    <ul>
      <li parentName="ul">{`vul bij `}<em parentName="li">{`User name`}</em>{` je Uurwerk gebruikersnaam in`}</li>
      <li parentName="ul">{`vul bij `}<em parentName="li">{`Password`}</em>{` je Uurwerk wachtwoord in`}</li>
      <li parentName="ul">{`klik op `}<em parentName="li">{`Connect`}</em>{`.`}</li>
    </ul>
    <p><img alt="Een OData feed instellen" src={require("../public/powerbi-odata-auth.png")} /></p>
    <p>{`Power BI verbindt nu met Uurwerk, en het `}<em parentName="p">{`Navigator`}</em>{`-scherm verschijnt.`}</p>
    <h2 {...{
      "id": "tabellen-instellen"
    }}>{`Tabellen instellen`}</h2>
    <p>{`In het `}<em parentName="p">{`Navigator`}</em>{`-scherm, dat na de vorige stap is verschenen,`}</p>
    <ul>
      <li parentName="ul">{`vink alle tabellen aan: Evenement, Dienst, GepubliceerdRooster, en Medewerker,`}</li>
      <li parentName="ul">{`klik op `}<em parentName="li">{`Load`}</em></li>
    </ul>
    <p><img alt="De OData feed instellen: tabellen kiezen" src={require("../public/powerbi-navigator-selected.png")} /></p>
    <p>{`Power BI laadt nu de tabellen in uit Uurwerk. Na het laden zijn de aangevinkte tabellen beschikbaar in Power BI.`}</p>
    <p><img alt="Power BI laadt nu de tabellen in uit Uurwerk" src={require("../public/powerbi-load-data.gif")} /></p>
    <p>{`Je kunt nu met Power BI aan de slag met gegevens uit Uurwerk.`}</p>
    <h2 {...{
      "id": "meer-informatie-over-power-bi-desktop"
    }}>{`Meer informatie over Power BI Desktop?`}</h2>
    <p>{`Lees de `}<a parentName="p" {...{
        "href": "https://docs.microsoft.com/nl-nl/power-bi/desktop-what-is-desktop"
      }}>{`introductie door Microsoft`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      